var React = require('react');

function Speaker (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#2F73A7","strokeLinejoin":"round","strokeWidth":"10","d":"M133 40L71 93H13v68h57l63 54z"}));
}

Speaker.defaultProps = {"viewBox":"0 0 256 256"};

module.exports = Speaker;

Speaker.default = Speaker;
